import getFilterableMailListContextMenuItems from './getFilterableMailListContextMenuItems';
import getMailListContextMenuItems from './getMailListContextMenuItems';
import getMailListItemPartContextMenuItems from './getMailListItemPartContextMenuItems';
import { menuKeysInOrder } from '../utils/menuKeysInOrder';
import { ContextualMenu, DirectionalHint } from '@fluentui/react/lib/ContextualMenu';
import { IPoint } from '@fluentui/react/lib/Utilities';
import { observer } from 'mobx-react-lite';
import { OwaDate } from 'owa-datetime';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getCategoryMenuPropertiesForContextMenu } from 'owa-mail-category-view';
import createSnoozeSubMenu from 'owa-mail-datepicker/lib/utils/createSnoozeSubMenu';
import getSnoozeDateOptions from 'owa-mail-datepicker/lib/utils/getSnoozeDateOptions';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { listViewStore } from 'owa-mail-list-store';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { getMoveToPropertiesForContextMenu } from 'owa-mail-movetofolder-view/lib/components/getMoveToMenuProperties';
import shouldShowUnstackedReadingPane from 'owa-mail-store/lib/utils/shouldShowUnstackedReadingPane';
import * as React from 'react';
import { onSnooze } from 'owa-mail-commands';
export interface MailListItemContextMenuProps {
    anchorPoint: IPoint;
    menuType: MailListContextMenuType;
    menuSource?: MailListContextMenuSource;
    tableViewId: string;
    onDismiss: (ev?: any) => void;
}

const MailListItemContextMenu = observer(function MailListItemContextMenu(
    props: MailListItemContextMenuProps
) {
    const { anchorPoint, menuType, menuSource } = props;
    let menuProps = null;
    const tableView = listViewStore.tableViews.get(props.tableViewId);
    const tableViewId = props.tableViewId;
    const onDismiss = props.onDismiss;

    if (menuType === MailListContextMenuType.All) {
        const defaultProps = {
            shouldFocusOnMount: true,
            target: anchorPoint,
            directionalHint: DirectionalHint.bottomLeftEdge,
            onDismiss: props.onDismiss,
            calloutProps: { preventDismissOnScroll: true }, // Prevent setting scrolltop from reading pane to dismiss the right click context menu
        };
        if (
            menuSource == MailListContextMenuSource.MailListItem ||
            shouldShowUnstackedReadingPane()
        ) {
            // If setting is unstacked reading pane, show same options for itemparts as that in message view.
            const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
            const items = isFeatureEnabled('tri-ml-menuShort')
                ? getMailListContextMenuItems(
                      selectedRowKeys,
                      tableViewId,
                      onDismiss,
                      menuKeysInOrder
                  )
                : getFilterableMailListContextMenuItems(selectedRowKeys, tableViewId, onDismiss);
            menuProps = {
                ...defaultProps,
                items: items.filter(item => item.shouldShow()),
            };
        } else {
            menuProps = {
                ...defaultProps,
                items: getMailListItemPartContextMenuItems(
                    listViewStore.expandedConversationViewState.selectedNodeIds,
                    tableViewId,
                    onDismiss
                ),
            };
        }
    } else {
        const defaultProps = {
            shouldFocusOnMount: true,
            target: anchorPoint,
            onDismiss: props.onDismiss,
        };
        if (menuType === MailListContextMenuType.MoveTo) {
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
            menuProps = {
                ...defaultProps,
                ...getMoveToPropertiesForContextMenu(
                    tableViewId,
                    onDismiss,
                    'Keyboard',
                    shouldShowBehaviorMap,
                    DirectionalHint.rightTopEdge,
                    null
                ),
            };
        } else if (menuType === MailListContextMenuType.Categorize) {
            menuProps = {
                ...defaultProps,
                ...getCategoryMenuPropertiesForContextMenu(
                    tableViewId,
                    onDismiss,
                    'Keyboard',
                    true
                ),
            };
        } else if (menuType === MailListContextMenuType.Snooze) {
            const snoozeDateOptions = getSnoozeDateOptions();
            const onSnoozeAction = (date?: OwaDate) => {
                onSnooze(date, 'Keyboard');
            };

            menuProps = {
                ...defaultProps,
                ...createSnoozeSubMenu(
                    onSnoozeAction,
                    snoozeDateOptions,
                    DirectionalHint.rightTopEdge
                ),
            };
        }
        menuProps.directionalHintFixed = false;
    }

    return <ContextualMenu {...menuProps} />;
});
export default MailListItemContextMenu;
